import { LOGIN_METHOD } from 'constants/api';
import { LOGIN_METHOD_ENUM } from 'constants/authentication';
import { useCallback, useState } from 'react';

type TUseCloudflareProps = {
  firebaseId: string | null;
};

export const useCloudflare = ({ firebaseId }: TUseCloudflareProps) => {
  // enable cloudflare auth
  const shouldAutoLogin =
    sessionStorage.getItem(LOGIN_METHOD) === LOGIN_METHOD_ENUM.CLOUDFLARE ||
    !firebaseId;
  const [isCloudflareAutoLoginEnabled, setIsCloudflareAutoLoginEnabled] =
    useState<boolean>(shouldAutoLogin);

  const toggleCloudflareAutoLogin = useCallback((enabled: boolean) => {
    setIsCloudflareAutoLoginEnabled(enabled);
    if (enabled) {
      sessionStorage.setItem(LOGIN_METHOD, LOGIN_METHOD_ENUM.CLOUDFLARE);
    } else {
      sessionStorage.removeItem(LOGIN_METHOD);
    }
  }, []);

  return { isCloudflareAutoLoginEnabled, toggleCloudflareAutoLogin };
};
